import Color from "color";

export default function useAutoIterations({
  backgroundColor,
  primaryColor,
  secondaryColor
}: {
  backgroundColor: string;
  primaryColor?: string;
  secondaryColor?: string;
}) {
  const backgroundColorAsColor = Color(backgroundColor);
  const primaryColorAsColor = Color(primaryColor);
  const secondaryColorAsColor = Color(secondaryColor);

  const blackHover = Color("#000")
    .lightness(10)
    .hex();

  const blackActive = Color("#000")
    .lightness(20)
    .hex();

  const autoInteractionsStyles = {
    hover: {
      backgroundColor: "",
      primaryColor: "",
      secondaryColor: ""
    },
    active: {
      backgroundColor: "",
      primaryColor: "",
      secondaryColor: ""
    }
  };

  if (backgroundColorAsColor.isLight()) {
    autoInteractionsStyles.hover.backgroundColor = backgroundColorAsColor
      .darken(0.1)
      .hex();
    autoInteractionsStyles.active.backgroundColor = backgroundColorAsColor
      .darken(0.2)
      .hex();
  } else {
    if (backgroundColor === "#000" || backgroundColor === "#000000") {
      autoInteractionsStyles.hover.backgroundColor = blackHover;
      autoInteractionsStyles.active.backgroundColor = blackActive;
    } else {
      autoInteractionsStyles.hover.backgroundColor = backgroundColorAsColor
        .lighten(0.1)
        .hex();
      autoInteractionsStyles.active.backgroundColor = backgroundColorAsColor
        .lighten(0.2)
        .hex();
    }
  }

  if (primaryColorAsColor.isLight()) {
    autoInteractionsStyles.hover.primaryColor = primaryColorAsColor
      .darken(0.1)
      .hex();
    autoInteractionsStyles.active.primaryColor = primaryColorAsColor
      .darken(0.2)
      .hex();
  } else {
    if (primaryColor === "#000" || primaryColor === "#000000") {
      autoInteractionsStyles.hover.primaryColor = blackHover;
      autoInteractionsStyles.active.primaryColor = blackActive;
    } else {
      autoInteractionsStyles.hover.primaryColor = primaryColorAsColor
        .lighten(0.1)
        .hex();
      autoInteractionsStyles.active.primaryColor = primaryColorAsColor
        .lighten(0.2)
        .hex();
    }
  }

  if (secondaryColorAsColor.isLight()) {
    autoInteractionsStyles.hover.secondaryColor = secondaryColorAsColor
      .darken(0.1)
      .hex();
    autoInteractionsStyles.active.secondaryColor = secondaryColorAsColor
      .darken(0.2)
      .hex();
  } else {
    if (secondaryColor === "#000" || secondaryColor === "#000000") {
      autoInteractionsStyles.hover.secondaryColor = blackHover;
      autoInteractionsStyles.active.secondaryColor = blackActive;
    } else {
      autoInteractionsStyles.hover.secondaryColor = secondaryColorAsColor
        .lighten(0.1)
        .hex();
      autoInteractionsStyles.active.secondaryColor = secondaryColorAsColor
        .lighten(0.2)
        .hex();
    }
  }

  return autoInteractionsStyles;
}
